/*!

=========================================================
* Material Dashboard PRO React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserHistory } from 'history'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'

// core components
import App from './layouts/App.js'

import 'assets/scss/material-dashboard-pro-react.scss?v=1.9.0'
import './index.css'

// ag-grid css
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'

import { LicenseManager } from 'ag-grid-enterprise'

const key = 'CompanyName=The Retail Data Partnership Ltd,LicensedApplication=Atlas,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-038034,SupportServicesEnd=7_April_2024_[v2]_MTcxMjQ0NDQwMDAwMA==9ca66c0eac0035a7df34904d253c8c51'

LicenseManager.setLicenseKey(key)

const hist = createBrowserHistory()

const container = document.getElementById('root')

const root = createRoot(container)

root.render(
  <Router history={hist}>
    <Switch>
      <Route path="/app" component={App} />
      <Redirect from="/" to="/app/dashboard" />
    </Switch>
  </Router>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
